import { Injectable } from '@angular/core';
import { Purpose } from 'src/app/api/autogenerated/types.gen';
import { DocumentDetails } from 'src/app/types/DocumentDetails';
import { FilePurpose } from 'src/app/types/FileTypes';
import { Invoice } from 'src/app/types/Invoice';
import { PaymentMethodDetails } from 'src/app/types/PaymentDetails';
import { Payout } from 'src/app/types/Payout';
import { FileUploadResponse } from 'src/app/types/responses/FileUploadResponse';
import { CoreService } from '../../core.service';
import { IFileService } from '../IFileService';

@Injectable({
  providedIn: 'root',
})
export class MockFileService implements IFileService {
  constructor(private _coreService: CoreService) {}

  async uploadFile(
    file: File,
    type: FilePurpose,
    _customerId?: string,
  ): Promise<FileUploadResponse> {
    const uuid = crypto.randomUUID();
    return this._coreService.delayResolve({ fileId: uuid });
  }

  async getFile(
    fileId: string,
    filePurpose: FilePurpose,
  ): Promise<DocumentDetails> {
    return this._coreService.delayResolve({ fileId: fileId });
  }

  async getCustomerFileContent(
    customerId: string,
    fileId: string,
    purpose: Purpose,
    fileMetadata: Pick<DocumentDetails, 'name' | 'mediaType' | 'size'> = {},
  ): Promise<DocumentDetails> {
    const mockFile = new File(
      ['Mock file content'],
      fileMetadata.name ?? 'document.pdf',
      { type: fileMetadata.mediaType ?? 'application/pdf' },
    );

    return this._coreService.delayResolve({
      fileId,
      name: fileMetadata.name ?? mockFile.name,
      mediaType: fileMetadata.mediaType ?? mockFile.type,
      size: fileMetadata.size,
      type: purpose,
      file: mockFile,
    });
  }

  async getFilesByCustomerId(customerId: string): Promise<DocumentDetails[]> {
    return this._coreService.delayResolve([]);
  }

  async deleteFile(fileId: string): Promise<void> {
    return this._coreService.delayResolve(undefined);
  }

  async generateHdfcIrmReport(
    payout: Payout,
    invoice: Invoice,
    bankAccountDetails: PaymentMethodDetails,
    partnerName?: string,
  ): Promise<Blob> {
    // Return a mock Excel blob
    const mockExcelData = 'Mock Excel Data';
    return this._coreService.delayResolve(
      new Blob([mockExcelData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
  }

  async generateHdfcRequestLetter(
    payout: Payout,
    invoice: Invoice,
    bankAccountDetails: PaymentMethodDetails,
    partnerName?: string,
  ): Promise<Blob> {
    // Return a mock PDF blob
    const mockPdfData = 'Mock PDF Data';
    return this._coreService.delayResolve(
      new Blob([mockPdfData], { type: 'application/pdf' }),
    );
  }
}
